const ADD_REQUEST = 'utm/ADD_REQUEST'
const ADD_RESULT = 'utm/ADD_RESULT'
const ADD_QUERY_PARAM = 'utm/ADD_QUERY_PARAM'

const INITIAL_VALUES = {
  isAlreadySent: false,
  values: {},
  queryParams: '',
}

export default function reducer(state = INITIAL_VALUES, action) {
  switch (action.type) {
    case ADD_REQUEST:
      return {
        ...state,
        values: {
          ...state.values,
          ...action.utmValues,
        },
      }

    case ADD_RESULT:
      return {
        ...state,
        isAlreadySent: true,
      }

    case ADD_QUERY_PARAM:
      return {
        ...state,
        queryParams: action.utmQueryParam,
      }

    default:
      return state
  }
}

export function addUtmTracking(utmValues) {
  return { type: ADD_REQUEST, utmValues }
}

export function addUtmQueryParam(utmQueryParam) {
  return { type: ADD_QUERY_PARAM, utmQueryParam }
}

export function addUtmTrackingResult() {
  return { type: ADD_RESULT }
}
